import { ActiveAlarms, PendingAlarms, AcknowledgedAlarms, UnacknowledgedAlarms } from "../../components/cards";
import { DonutChart, CustomerColumnChart, SiteColumnChart } from "../../components/charts";
import { BureauCategory } from "../../components/alarms";

interface Props {
    searchQuery: string;
    category: string;
    onSearchChange: (value: string) => void;
    onCategoryChange: (value: string) => void;
}

export function DashboardOverview({ searchQuery, category, onSearchChange, onCategoryChange }: Props) {
    return (
        <>
            <div className="row gap-1 mb-1">
                <div className="col-12-xs col-6-md col-3-lg"><ActiveAlarms /></div>
                <div className="col-12-xs col-6-md col-3-lg"><AcknowledgedAlarms /></div>
                <div className="col-12-xs col-6-md col-3-lg"><UnacknowledgedAlarms /></div>
                <div className="col-12-xs col-6-md col-3-lg"><PendingAlarms /></div>
            </div>
            <div className="row gap-1 mb-2">
                <div className="col-12-xs col-4-md stretch"><CustomerColumnChart /></div>
                <div className="col-12-xs col-4-md stretch"><DonutChart /></div>
                <div className="col-12-xs col-4-md stretch"><SiteColumnChart /></div>
            </div>
            <div className="col-12-xs">
                <BureauCategory tableOnly showSortSummary searchQuery={searchQuery} onSearchChange={onSearchChange}
                    initialCategory={category} onCategoryChange={onCategoryChange} />
            </div>
        </>
    );
}
